@let isAlert = $role() === 'alert' || hostClasses.includes('alert'); @let isInfo = ($popover() !== '' && $role() ===
'info') || hostClasses.includes('info'); @let isSuccess = $role() === 'success' || hostClasses.includes('success'); @let
isWarning = $role() === 'warning' || hostClasses.includes('warning'); @let hasSvg = isAlert || isInfo || isSuccess ||
isWarning; @if ($isReady()) {
<h4 class="toast-title">
  @if (hasSvg) {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    aria-hidden="true"
    focusable="false"
    stroke-linecap="round"
  >
    @if (isAlert) {
    <!-- prettier-ignore -->
    <path d="M388.2 64.1C405.2 64.1 421.5 70.8 433.5 82.8L557.6 206.9C569.6 218.9 576.3 235.2 576.3 252.1L576.3 387.7C576.3 404.7 569.5 420.9 557.6 432.9L433.5 557.2C421.5 569.2 405.2 576 388.2 576L252.6 576C235.6 576 219.3 569.2 207.4 557.2L83.3 433C71.3 421 64.5 404.8 64.5 387.8L64.5 252.2C64.5 235.2 71.3 218.9 83.3 207L207.4 82.8C219.4 70.8 235.7 64.1 252.6 64.1L388.2 64.1zM320.4 384C302.7 384 288.4 398.3 288.4 416C288.4 433.7 302.7 448 320.4 448C338.1 448 352.4 433.7 352.4 416C352.4 398.3 338.1 384 320.4 384zM320.4 192C302.2 192 287.7 207.5 289 225.7L296.4 329.7C297.3 342.3 307.8 352 320.3 352C332.9 352 343.3 342.3 344.2 329.7L351.6 225.7C352.9 207.5 338.5 192 320.2 192z"/>
    } @else if (isInfo) {
    <!-- prettier-ignore -->
    <path d="M320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576zM288 224C288 206.3 302.3 192 320 192C337.7 192 352 206.3 352 224C352 241.7 337.7 256 320 256C302.3 256 288 241.7 288 224zM280 288L328 288C341.3 288 352 298.7 352 312L352 400L360 400C373.3 400 384 410.7 384 424C384 437.3 373.3 448 360 448L280 448C266.7 448 256 437.3 256 424C256 410.7 266.7 400 280 400L304 400L304 336L280 336C266.7 336 256 325.3 256 312C256 298.7 266.7 288 280 288z"/>
    } @else if (isWarning) {
    <!-- prettier-ignore -->
    <path d="M320 64C334.7 64 348.2 72.1 355.2 85L571.2 485C577.9 497.4 577.6 512.4 570.4 524.5C563.2 536.6 550.1 544 536 544L104 544C89.9 544 76.8 536.6 69.6 524.5C62.4 512.4 62.1 497.4 68.8 485L284.8 85C291.8 72.1 305.3 64 320 64zM320 416C302.3 416 288 430.3 288 448C288 465.7 302.3 480 320 480C337.7 480 352 465.7 352 448C352 430.3 337.7 416 320 416zM320 224C301.8 224 287.3 239.5 288.6 257.7L296 361.7C296.9 374.2 307.4 384 319.9 384C332.5 384 342.9 374.3 343.8 361.7L351.2 257.7C352.5 239.5 338.1 224 319.8 224z"/>
    } @else if (isSuccess) {
    <!-- prettier-ignore -->
    <path d="M320 576C178.6 576 64 461.4 64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576zM438 209.7C427.3 201.9 412.3 204.3 404.5 215L285.1 379.2L233 327.1C223.6 317.7 208.4 317.7 199.1 327.1C189.8 336.5 189.7 351.7 199.1 361L271.1 433C276.1 438 282.9 440.5 289.9 440C296.9 439.5 303.3 435.9 307.4 430.2L443.3 243.2C451.1 232.5 448.7 217.5 438 209.7z"/>
    }
  </svg>
  }
  <span [innerHTML]="$titleHtml()"></span>
</h4>

@let isSupport = $support() !== null && $supportText() !== ''; @if (isSupport) {
<div class="toast-body-container">
  <p class="toast-body" [innerHTML]="$bodyHtml()"></p>
  <p class="toast-body" [innerHTML]="$supportText()"></p>
</div>
} @else {
<p class="toast-body" [innerHTML]="$bodyHtml()"></p>
} @if (($popover() === '' && $isClosable()) || $popover() !== '') {
<!-- prettier-ignore -->
<button type="button" class="toast-dismiss" aria-label="Dismiss notification" [attr.popovertargetaction]="$popover() !== '' ? 'hide' : null" [attr.popovertarget]="$popover() !== '' ? $id() : null" (click)='$popover() === "" ? declarativeDismiss() : null'>
  <!-- prettier-ignore -->
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" stroke-linecap="round">
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
</button>
} }
